import { MEMBERSHIP_SKUS } from "../../../DiscoveryJourneyModal";
import type { GiftContentResponse, WelcomeGiftCardContentProps } from "./types";

export const welcomeGiftCardContentPerMembership = ({
  welcomeGift,
  currentMembershipSku
}: WelcomeGiftCardContentProps): GiftContentResponse | null => {
  const commonContent = {
    imageUrl:
      "https://beautypie.bynder.com/m/9ad4823bce55a43/webimage-MEMBER_PERKS_DESK_WEB.jpg",
    title: "Welcome Gift"
  };

  if (welcomeGift) {
    return {
      ...commonContent,
      description:
        "Here's a gift on us to say thank you for joining Beauty Pie+"
    };
  }

  if (MEMBERSHIP_SKUS.freeTrial.includes(currentMembershipSku)) {
    return {
      ...commonContent,
      description:
        "Get a FREE welcome gift when you become a fully-fledged Beauty Pie+ member"
    };
  }

  return null;
};
